import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// feature flag
import ViewerSocialProfileModel from 'models/user/ViewerSocialProfile';
import {
    gcPlusExBadgesRoleKey // Clean up ticket: CA-171397
} from 'models/preferences/PreferencesMapping';
import { getSystemPreferenceValue } from 'reducers/system/systemPreferences';

/** i18n */
import { withTranslation } from 'react-i18next';
import Translate from 'components/Translate';

import {
    isRepeatableBadge,
    isLimitedTimeBadge,
    isBadgeChallengeBadge,
    isRetiredBadge,
    isPremiumBadge
} from 'utils/BadgeUtils';

import styles from './BadgeTags.module.css';

const BadgeTags = (props) => {
    const { badge, hidePremium } = props;

    const gcPlusExBadgesFeatureOn = useSelector((state) => {
        const featureFlagValue = getSystemPreferenceValue(state, gcPlusExBadgesRoleKey); // Cleanup ticket: CA-171397
        return ViewerSocialProfileModel.hasRole(featureFlagValue);
    });

    const isLimitedTime = isLimitedTimeBadge(badge);
    const isRepeatable = isRepeatableBadge(badge);
    const isBadgeChallenge = isBadgeChallengeBadge(badge);
    const isRetired = isRetiredBadge(badge);
    const isPremium = !hidePremium && gcPlusExBadgesFeatureOn && isPremiumBadge(badge);

    const noTag = !isBadgeChallenge && !isRepeatable && !isLimitedTime && !isPremium;

    const showLimitedTimeTag = (!isRepeatable && isLimitedTime) || (isRepeatable && isRetired);

    if (noTag) {
        return null;
    }

    return (
        <div className={styles.badgeTags}>
            {showLimitedTimeTag && (
                <span className={styles.badgeTag}>
                    <Translate ns="badges" content="limited_time" />
                </span>
            )}
            {isRepeatable && (
                <span className={styles.badgeTag}>
                    <Translate ns="badges" content="repeatable" />
                </span>
            )}
            {isBadgeChallenge && (
                <span className={styles.badgeTag}>
                    <Translate ns="challengewidget" content="challenge" />
                </span>
            )}
            {isPremium && <span className={styles.badgeTag}>Garmin Connect+</span>}
        </div>
    );
};
BadgeTags.propTypes = {
    badge: PropTypes.object.isRequired,
    hidePremium: PropTypes.bool
};

export default withTranslation(['badges', 'challengewidget'])(BadgeTags);
